export const EMPTY_COUNTRY_INFO = {
  populationLabel: '',
  capitalLabel: '',
  regionLabel: '',
};

export function formatPopulation(population) {
  const value = Number(population);
  if (!Number.isFinite(value) || value <= 0) return '';
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)} Mil`;
  return value.toLocaleString();
}

export function displayCapital(capital) {
  if (!capital) return '';
  if (Array.isArray(capital)) return capital[0] || '';
  return String(capital);
}

export function displayRegion(region) {
  if (!region || region === 'Unknown') return '';
  return String(region);
}

/** Normalize DB rows, REST Countries payloads, or prop objects into panel labels. */
export function normalizeCountryInfo(source) {
  if (!source) return { ...EMPTY_COUNTRY_INFO };

  const population = source.population ?? source.populationLabel;
  const capital = source.capital ?? source.capitals?.[0]?.name ?? source.capitalLabel;
  const region = source.region ?? source.subregion ?? source.regionLabel;

  return {
    populationLabel: formatPopulation(population),
    capitalLabel: displayCapital(capital),
    regionLabel: displayRegion(region),
  };
}
